export const typesOfMultipleLocations = {
  object: 'object',
  id: 'id',
};
